import { db } from "./db";
import type { ImportRecord } from "./imports";
import type { GnomuxFile } from "./objects";

/** Persist a new import record so it survives tab crashes. */
export async function createImportRecord(record: ImportRecord): Promise<void> {
  await db.imports.put(record);
}

/** Update an in-flight import record (e.g. status transitions). */
export async function updateImportStatus(
  id: string,
  changes: Partial<ImportRecord>,
): Promise<void> {
  await db.imports.update(id, changes);
}

/** Remove a completed or cancelled import record. */
export async function deleteImportRecord(id: string): Promise<void> {
  await db.imports.delete(id);
}

/**
 * Write a placeholder object into the object store.
 *
 * Used to show an "importing" or "error" entry in the file tree while the
 * upload worker processes the file.
 */
export async function putObjectPlaceholder(
  obj: Record<string, unknown>,
): Promise<void> {
  await db.objects.put(obj as never);
}

/** Replace the placeholder with the fully ingested file object. */
export async function finalizeImportedObject(obj: GnomuxFile): Promise<void> {
  await db.objects.put(obj as never);
}

/** Delete an object (e.g. placeholder cleanup on cancellation or abort). */
export async function deleteObject(id: string): Promise<void> {
  await db.objects.delete(id);
}
